import { Injectable } from '@angular/core';
import { ConfigService } from '../../core/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class OAuthUrlService {

  constructor(private configService: ConfigService) { }

  async buildPortalAliadosOAuthUrl(): Promise<string> {
    const config = this.configService.getConfig();
    const cognitoConfig = config.cognitoConfig;

    const authBaseUrl = config.portalAliadosUrl.replace('/login', '');
    const redirectUri = cognitoConfig.REDIRECTSIGNINURIS[0];

    const state = this.generateState();
    const codeVerifier = this.generateCodeVerifier();
    const codeChallenge = await this.generateCodeChallenge(codeVerifier);

    localStorage.setItem('oauth_code_verifier', codeVerifier);
    localStorage.setItem('oauth_state', state);

    const params = new URLSearchParams({
      name: '',
      client_id: cognitoConfig.CLIENTID,
      redirect_uri: redirectUri,
      state: state,
      scope: 'email openid profile',
      code_challenge: codeChallenge,
      code_challenge_method: 'S256'
    });

    return `${authBaseUrl}/login?${params.toString()}`;
  }

  async buildCognitoDirectOAuthUrl(): Promise<string> {
    const config = this.configService.getConfig();
    const cognitoConfig = config.cognitoConfig;

    const authBaseUrl = `https://${cognitoConfig.DOMAIN}`;
    const redirectUri = cognitoConfig.REDIRECTSIGNINURIS[0];

    const state = this.generateState();
    const codeVerifier = this.generateCodeVerifier();
    const codeChallenge = await this.generateCodeChallenge(codeVerifier);

    localStorage.setItem('oauth_code_verifier', codeVerifier);
    localStorage.setItem('oauth_state', state);

    const params = new URLSearchParams({
      client_id: cognitoConfig.CLIENTID,
      redirect_uri: redirectUri,
      response_type: 'code',
      state: state,
      scope: 'email openid profile',
      code_challenge: codeChallenge,
      code_challenge_method: 'S256'
    });

    return `${authBaseUrl}/oauth2/authorize?${params.toString()}`;
  }

  private generateState(): string {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }

  private generateCodeVerifier(): string {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }

  private async generateCodeChallenge(codeVerifier: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const base64String = btoa(String.fromCharCode(...new Uint8Array(hashBuffer)));

    return base64String
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }
}
